export default __webpack_public_path__ + "static/media/blog-details-thumb-5.0dab58e5.jpg";